import { Algolia, Hits } from '@/infrastructure/network/Algolia/schema'
import { AlgoliaRequest } from '@/infrastructure/network/AlgoliaRequest'

export class FetchCompany implements AlgoliaRequest<Algolia.Company.FetchCompanyResponse> {
  response: Algolia.Company.FetchCompanyResponse
  index: string
  items: string
  hits?: Hits
  word: string
  constructor(word?: string | null, hits?: Hits) {
    this.hits = hits
    this.word = word || ''
    this.index = `${process.env.SCOUT_PREFIX}companies`
    this.items = 'companies'
  }
}
